<div *ngIf="uploadSetting && showFileType" class="col-4" style="padding: 0.375rem 0.75rem; text-align: left;">{{ label.uploadType }}<span class="extention">{{uploadSetting.type}}</span></div>
<div class="qq-uploader-selector qq-uploader qq-gallery" attr.qq-drop-area-text="{{ label.dropAreaText }}" [style.cursor]="disabled? 'not-allowed':''">
  <input type="file" style="display: none" [id]="name" [multiple]="!single" (change)="fileInputOnChange($event)" #fileInput>
  <ul class="qq-upload-list" *ngIf="uploadSetting" [class.deny]="disabled">
    <li class="col-md-3 col-sm-6 qq-upload-list-selector" *ngFor="let file of files; let i = index" (click)="stopPropagation($event)">
      <ng-container *ngIf="file.thumbnailUrl; else fileTmp">
        <a target="_blank" href="{{file.thumbnailUrl}}">
          <ng-container *ngTemplateOutlet="fileTmp"></ng-container>
        </a>
      </ng-container>
      <ng-template #fileTmp>
        <div class="qq-thumbnail-wrapper">
          <img class="qq-thumbnail-selector" [src]="file.thumbnailUrl" >
        </div>
        <div class="qq-default-image" *ngIf="showRepresent && ((type == 'gallery') || (type == 'collection'))">
          <label>{{ label.representImg }}</label>
          <input title="{{ label.setRepresentImgTitle }}" type="radio" [value]="file.fileid"  [checked]="file.represent" (change)="representImg(file,files)" name="defaultImg-{{type}}-{{i}}">
        </div>
        <div class="qq-file-info">
          <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"><span>{{file.name}}</span></div>
          <ng-container *ngIf="!file.fileid && file.progress && file.progress > 0">
            <!-- <span class="qq-upload-size">{{ file.size | fileSize }}</span> -->
            <div class="progress form-group">
              <div class="progress-bar progress-bar-striped bg-success" role="progressbar" [style.width.%]="file.progress"></div>
            </div>
          </ng-container>
          <ng-container *ngIf="file.fileid">
            <button *ngIf="isCrop" class="qq-btn qq-upload-crop qq-upload-crop-selector" type="button" (click)="onOpenCrop($event, file, $any(type))">
              <span aria-label="Crop" class="glyphicon glyphicon-scissors"></span>
            </button>
            <button class="qq-btn qq-upload-delete-selector qq-upload-delete" type="button" (click)="deleteFile($event, file)">
              <span aria-label="Delete" class="fa fa-trash"></span>
            </button>
          </ng-container>
        </div>
      </ng-template>
    </li>
  </ul>
  <ngx-loading [show]="loading"></ngx-loading>
</div>
